$(function () {
	var acc = document.getElementsByClassName("accordion-opener");
	var i;

	for (i = 0; i < acc.length; i++) {
		acc[i].addEventListener("click", function () {
			this.classList.toggle("active");

			var panel = this.nextElementSibling;

			if (panel.style.display === "block") {
				panel.style.display = "none";
			} else {
				panel.style.display = "block";
			}
			$(this).find(".accordion-opener-text").toggleClass("down");
		});
	}

	// Move the Fields Personalizer app embed into the buybox slot after variant selection.
	(function relocateProductCustomFields() {
		var target = document.querySelector("[data-product-custom-fields-slot]");

		if (!target) {
			return;
		}

		var marketHandleEl = document.getElementById("MarketHandle");
		var marketHandle = marketHandleEl
			? marketHandleEl.getAttribute("data-market") || marketHandleEl.getAttribute("value")
			: "";
		var isPersonalizationMarket = marketHandle === "de" || marketHandle === "at";

		var moveEmbed = function () {
			var embed = document.getElementById("product-custom-fields-embed-wrapper");

			if (!embed) {
				return;
			}

			if (!isPersonalizationMarket) {
				embed.remove();
				return;
			}

			if (embed.parentElement === target) {
				return;
			}

			target.appendChild(embed);
		};

		moveEmbed();

		var observer = new MutationObserver(moveEmbed);
		observer.observe(document.documentElement, { childList: true, subtree: true });
	})();
});

$(window).load(function () {
	// Custom Google Tag Manager / GTM

	window.gtmTriggerPageView30s = function () {
		window.dataLayer.push({
			event: "gtm_page_view_30s",
		});

		console.log("[GTM] gtm_page_view_30s was pushed to data layer.");
	};

	setTimeout(function () {
		gtmTriggerPageView30s();
	}, 30 * 1000);

	// ?

	// Tree Counter Animation

	var treeCounterAnimation = (function () {
		var treeCounters = document.querySelectorAll("[tree-counter]");

		var startCount = function () {
			forEach(treeCounters, function (treeCounter, index) {
				// https://github.com/toddmotto/foreach
				var endValue = treeCounter.getAttribute("data-otp-count");
				var animation = new countUp.CountUp(treeCounter, endValue, {
					duration: 8,
					useGrouping: false,
				});
				animation.start();
			});
		};

		return { startCount };
	})();

	if (document.getElementById("tree-counter-container")) {
		var waypoint = new Waypoint({
			element: document.getElementById("tree-counter-container"),
			handler: function (direction) {
				if (direction === "down") {
					treeCounterAnimation.startCount();
				}
			},
			offset: "99%",
		});
	}

	// Judgeme Refresh (for recommended products section)
	const judgemeObserver = new MutationObserver(() => {
		if(typeof jdgm !== 'undefined' && jdgm.customizeBadges) {
			jdgm.customizeBadges();
		}
	});
	judgemeObserver.observe(document.documentElement, { childList: true, subtree: true });

});

// Angle-variant landing pages: GTM events + CTA query-string forwarding.
// Scoped to pages carrying #LpConfig (set by sections/lp-hero.liquid)
// so this never runs on PDP/collection/other templates.
$(function () {
	var landingConfigEl = document.getElementById("LpConfig");
	if (!landingConfigEl) {
		return;
	}

	var landingProduct = landingConfigEl.getAttribute("data-product") || "";
	var landingAngle = landingConfigEl.getAttribute("data-angle") || "";

	window.dataLayer = window.dataLayer || [];
	window.dataLayer.push({
		event: "landing_page_view",
		product: landingProduct,
		angle: landingAngle,
	});
	console.log("[GTM] landing_page_view was pushed to data layer.");

	var scroll50Fired = false;
	var checkScroll50 = function () {
		if (scroll50Fired) {
			return;
		}

		var docHeight = document.documentElement.scrollHeight - window.innerHeight;
		if (docHeight <= 0) {
			return;
		}

		var scrolled = window.scrollY / docHeight;
		if (scrolled < 0.5) {
			return;
		}

		scroll50Fired = true;
		window.removeEventListener("scroll", checkScroll50);

		window.dataLayer.push({
			event: "landing_page_scroll_50",
			product: landingProduct,
			angle: landingAngle,
		});
		console.log("[GTM] landing_page_scroll_50 was pushed to data layer.");
	};

	window.addEventListener("scroll", checkScroll50, { passive: true });
	checkScroll50();

	var incomingQueryString = window.location.search;

	$("[data-lp-cta]").each(function () {
		var cta = this;
		var baseHref = cta.getAttribute("href") || "";

		if (incomingQueryString) {
			var joiner = baseHref.indexOf("?") === -1 ? "?" : "&";
			cta.setAttribute("href", baseHref + joiner + incomingQueryString.slice(1));
		}

		cta.addEventListener("click", function () {
			window.dataLayer.push({
				event: "landing_page_cta_click",
				product: cta.getAttribute("data-product") || landingProduct,
				angle: cta.getAttribute("data-angle") || landingAngle,
				cta_position: cta.getAttribute("data-cta-position") || "",
			});
			console.log("[GTM] landing_page_cta_click was pushed to data layer.");
		});
	});
});
